import styles from "./ThreeDotsLoader.module.css";

const ThreeDotsLoader = () => {
  return (
    <div className={styles.loading}>
      <span className={styles.loading__dot}></span>
      <span className={styles.loading__dot}></span>
      <span className={styles.loading__dot}></span>
    </div>
  );
};

export default ThreeDotsLoader;
